import { Component, OnInit } from '@angular/core';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UsermanagementService } from '../../service/usermanagement/usermanagement.service';
import { AlertController, ModalController } from '@ionic/angular';
import { FormPage } from './form/form.page'
import { Router } from '@angular/router';
import { identity } from 'rxjs';

@Component({
  selector: 'app-useradmin',
  templateUrl: './useradmin.page.html',
  styleUrls: ['./useradmin.page.scss'],
})
export class UseradminPage implements OnInit {

  public subUserForm: FormGroup;
  public subUsers: any[] = [];
  private superUserId = ''; // Should be set based on the logged-in super user's ID

  constructor(
    private formBuilder: FormBuilder,
    private UsermanagementService: UsermanagementService,
    private alertController: AlertController,
    private modalController: ModalController,
    private router: Router
  ) {
    this.subUserForm = this.formBuilder.group({
      displayName: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      accessDocumentArchive: false,
      accessWeighinReceipts: false,
      accessSeasonalInfo: false
    });
  }

  ngOnInit() {
    this.loadSubUsers();
  }

  loadSubUsers(): void {console.log('LOAD')

    this.UsermanagementService.getSubUsers()
    .subscribe(users => { 
      this.subUsers = users;
    }, error => {
      console.error('Error fetching sub-users:', error);
      this.showAlert('Error', 'Failed to load sub-users');
    });
  }

  addOrEditSubUser(): void {
    if (this.subUserForm.valid) {
      const subUserInfo = this.subUserForm.value;
      // Adjust `subUserInfo` to match your API's expected format if necessary

      this.UsermanagementService.addSubUser(subUserInfo).subscribe({
        next: (result) => {
          //this.subUsers.push(result); // Update the local list of sub-users
          this.subUserForm.reset(); // Reset the form after successful submission
          this.showAlert('Success', 'Sub-user added successfully');
        },
        error: (error) => {
          console.error('Error adding sub-user:', error);
          this.showAlert('Error', 'Failed to add sub-user');
        }
      });
    }
  }

  async showAlert(header: string, message: string): Promise<void> {
    const alert = await this.alertController.create({
      header,
      message,
      buttons: ['OK'],
    });

    await alert.present();
  }

  private getSuperUserId(): string {
    // Implement logic to retrieve the super user's ID based on your authentication strategy
    // This could involve retrieving a stored token and parsing its payload
    return 'your-super-user-id'; // Placeholder; replace with actual logic
  }

  async presentModal(user?: any) {
    const modal = await this.modalController.create({
      component: FormPage,
      componentProps: { user: user }
    });
  
    await modal.present();
  
    const { data } = await modal.onWillDismiss();
    if (data) {
      console.log('retunr', data);
      // Find and update the user in your list
      if(data.action === 'added'){
        this.subUsers.push(data.data);
      }else if(data.action === 'updated'){
        const indexToUpdate = this.subUsers.findIndex(u => u.id === data.data.id);
        if (indexToUpdate !== -1) {
          this.subUsers[indexToUpdate] = data.data; // Replace with updated data
        }
      }else if(data.action === 'deleted'){console.log('deleted::::', data.id)
        this.subUsers = this.subUsers.filter(u => u.id !== data.id);
      }
    }
  }

  addUser() {
    this.presentModal();
    console.log('ADD');
  }
  
  editUser(user: any) {
    this.presentModal(user);
    console.log('EDIT', user);
  }

  backToHomepage() {
    this.router.navigate(['/asb/home']);
  }

}